module.exports = "https://web-assets-production.autolist.com/_next/static/images/about-us-hero-1f1089e0854d74502c4d899679c74b73.jpg";